/**
 * Toast
 * Notification alerts (toasts)
 * Author: Mayank Gureja
 * Date: 07/05/2019
 * Requires animate.css (https://daneden.github.io/animate.css)
 */

const defaults = {
  message: 'An event has occurred!',
  position: 'is-right',
  duration: 5000,
  dismissible: true,
  openAnimation: 'animate__bounceInRight',
  closeAnimation: 'animate__bounceOutRight',
};

const toast = (params = {}) => {
  const options = { ...defaults, ...params };

  let toastTop = document.querySelector('.toast.is-top');
  let toastBottom = document.querySelector('.toast.is-bottom');

  if (!toastTop || !toastBottom) {
    toastTop = document.createElement('div');
    toastBottom = document.createElement('div');

    toastTop.className = 'toast is-top';
    toastBottom.className = 'toast is-bottom';

    document.body.appendChild(toastTop);
    document.body.appendChild(toastBottom);
  }

  const toastElement = document.createElement('div');
  // Add notification class, along with animation classes
  const classes = ['toast-content', 'animate__animated', options.openAnimation, 'animate__faster'];

  if (options.type) classes.push(options.type);
  if (options.position) classes.push(options.position);

  toastElement.classList = classes.join(' ');

  if (options.dismissible) {
    // Can clock close button to dismiss
    const dismissButton = document.createElement('button');
    dismissButton.className = 'delete has-animation-rotate';

    dismissButton.addEventListener('click', () => {
      // Add animation
      toastElement.classList.add(options.closeAnimation);

      // Remove hidden toast div after animation completes
      setTimeout(() => toastElement.remove(), 1000);
    });

    toastElement.insertAdjacentElement('afterbegin', dismissButton);

    // Can also click anywhere on the Toast to dismiss
    toastElement.addEventListener('click', () => {
      // Add animation
      toastElement.classList.add(options.closeAnimation);

      // Remove hidden toast div after animation completes
      setTimeout(() => toastElement.remove(), 1000);
    });
  }

  const toastIcon = document.createElement('span');
  toastIcon.className = 'icon';
  let icon = '';
  switch (options.type) {
    case 'is-success':
      icon = 'fa-check-circle';
      break;
    case 'is-danger':
      icon = 'fa-exclamation-circle';
      break;
    case 'is-info':
      icon = 'fa-info-circle';
      break;
    default:
      icon = 'fa-bell';
      break;
  }
  toastIcon.innerHTML = `<i class="fas ${icon} fa-2x"></i>`;
  toastElement.insertAdjacentElement('afterbegin', toastIcon);

  toastElement.insertAdjacentHTML('beforeend', options.message);

  if (options.position.includes('is-top')) toastTop.appendChild(toastElement);
  else toastBottom.appendChild(toastElement);

  setTimeout(() => {
    // Add animation
    toastElement.classList.add(options.closeAnimation);

    // Remove hidden toast div after animation completes
    setTimeout(() => toastElement.remove(), 1000);
  }, options.duration);
};

export default toast;
